import { getTransportDiagnostics, type TransportDiagnostics } from './transportDiagnostics';

// Finite application error codes; unknown/provider-reflected strings are omitted.
const KNOWN_CODES = new Set([
  'ADJUSTMENT_VALIDATION_FAILED',
  'ALREADY_REFUNDED',
  'AUTH_STATE_TIMEOUT',
  'AUTH_TOKEN_TIMEOUT',
  'BILL_QUOTE_STALE',
  'CARD_EXPIRED',
  'CARD_INACTIVE',
  'CARD_LIMIT_EXCEEDED',
  'CARD_NOT_FOUND',
  'CARD_REGISTRATION_FAILED',
  'CARD_REQUIRED_FOR_CHARGE',
  'CHECKOUT_EXPIRED',
  'CLIENT_ERROR',
  'CONCURRENT_SETTLEMENT',
  'CONSENT_REQUIRED',
  'CSRF_INIT_ERROR',
  'DUPLICATE_CARD',
  'DUPLICATE_PARTY',
  'GPS_UNAVAILABLE',
  'INTERNAL',
  'INVALID_COMBINATION',
  'INVALID_CREDENTIALS',
  'INVALID_PARAM',
  'INVALID_PARAMETER',
  'INVALID_RESPONSE',
  'INVALID_TRANSITION',
  'NETWORK_ERROR',
  'NETWORK_TIMEOUT',
  'ORDER_ALREADY_PAID',
  'ORDER_NOT_PAYABLE',
  'OVERRIDE_FAILED',
  'PARSE_ERROR',
  'PARTY_NOT_FOUND',
  'PARTY_SIZE_TOO_LARGE',
  'PAYMENT_AMOUNT_MISMATCH',
  'PAYMENT_DUPLICATE',
  'PAYMENT_NOT_SETTLEABLE',
  'PROVIDER_ERROR',
  'PROVIDER_UNAVAILABLE',
  'QR_INACTIVE',
  'QUEUE_INACTIVE',
  'QUEUE_PAUSED',
  'REFUND_EXCEEDS_AMOUNT',
  'REFUND_NOT_SUPPORTED',
  'REQUEST_FAILED',
  'SESSION_EXPIRED',
  'SETTLEMENT_FAILED',
  'STORAGE_UNAVAILABLE',
  'STORE_NOT_FOUND',
  'TIMEOUT',
  'TOO_FAR',
  'UNAUTHORIZED',
  'WAITLIST_CLOSED',
  'WAITLIST_NOT_CALLED',
  'WAITLIST_REQUIRED',
  'WEBHOOK_INVALID',
  'WEBHOOK_SECRET_NOT_CONFIGURED',
  'WEBHOOK_SIGNATURE_FAILED',
]);
const KNOWN_TYPES = new Set(['Error', 'TypeError', 'SyntaxError', 'DOMException', 'ApiClientError', 'BloominInitiateError', 'FirebaseError', 'SecurityError', 'QuotaExceededError', 'AbortError']);
export function isErrorValue(error: unknown): error is Error | DOMException {
  return error instanceof Error || (typeof DOMException !== 'undefined' && error instanceof DOMException);
}
export function safeErrorCode(code: unknown): string | undefined {
  return typeof code === 'string' && KNOWN_CODES.has(code) ? code : undefined;
}
export function safeErrorMetadata(error: unknown): { type: string; status?: number; code?: string; transport?: TransportDiagnostics } | undefined {
  if (!isErrorValue(error)) return undefined;
  try {
    const candidate = error as Error & { status?: unknown; code?: unknown };
    const status = candidate.status;
    const name = error.name;
    const code = safeErrorCode(candidate.code);
    const transport = getTransportDiagnostics(error);
    return {
      type: KNOWN_TYPES.has(name) ? name : 'Error',
      ...(typeof status === 'number' && Number.isInteger(status) && (status === 0 || (status >= 100 && status <= 599)) ? { status } : {}),
      ...(code ? { code } : {}),
      ...(transport ? { transport } : {}),
    };
  } catch { return { type: 'Error' }; }
}
